<p-toast styleClass="es-growl"></p-toast>
<ng-progress [spinner]="false" class="top-progress-bar" color="#5f94ff"></ng-progress>
@if (menuItems().length) {
	<evs-navigation [menuItems]="menuItems()">
		<router-outlet></router-outlet>
	</evs-navigation>
}
